/**
 * 5-star row used for review ratings. Renders filled / outlined stars.
 *
 * @param {number} value - 0..5 rating; rounded to nearest integer for fill.
 * @param {number} size - Star size in px.
 */
import { StarsStyles } from "./stars.styles";

const StarIcon = ({ filled, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill={filled ? "#E0A800" : "none"}
    stroke="#E0A800"
    strokeWidth="1"
    aria-hidden="true"
  >
    <path d="M6 1l1.5 3.2 3.5.4-2.6 2.4.7 3.4L6 8.7 2.9 10.4l.7-3.4L1 4.6l3.5-.4L6 1z" />
  </svg>
);

const Stars = ({ value = 0, size = 12 }) => {
  const full = Math.round(value);
  return (
    <StarsStyles>
      {[1, 2, 3, 4, 5].map(i => (
        <StarIcon key={i} filled={i <= full} size={size} />
      ))}
    </StarsStyles>
  );
};

export default Stars;
